export function diffSetLayer(originLayers, needRemoveLayers) {
    return originLayers.filter((originLayer) => !needRemoveLayers.some((layer) => layer === originLayer));
}
